export type Language = 'es' | 'en'

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      experience: 'La experiencia',
      gallery: 'Galería',
      reviews: 'Reseñas',
      faq: 'FAQ',
    },
    hero: {
      headline: 'Tu Día Privado en el Caribe Comienza Aquí',
      subheadline:
        'Navega desde Fajardo hacia Icacos y Palominos en una experiencia privada diseñada para disfrutar el mar a tu ritmo.',
      cta: 'Reserva con Blu Ocean',
    },
    bluOceanSection: {
      title: 'Un Día en el Mar, Hecho Para Ti',
      description:
        'Blu Ocean Tours te lleva a descubrir las aguas cristalinas del este de Puerto Rico en un bote privado para hasta 6 personas. Música, snorkel, bebidas, snacks y tiempo para disfrutar cada parada.',
      features: [
        {
          title: 'Bote Privado',
          desc: 'Exclusivo para ti y tu grupo, hasta 6 personas.',
        },
        {
          title: 'Icacos + Palominos',
          desc: 'Navega hacia los cayos más espectaculares del este.',
        },
        {
          title: 'Todo Incluido',
          desc: 'Bebidas, snacks, snorkel y colchón flotante.',
        },
        {
          title: 'Opción de Jet Ski',
          desc: 'Añade adrenalina a tu día en el mar.',
        },
      ],
      cta: 'Reserva tu tour privado',
    },
    whyBookUs: {
      title: '¿Por Qué Navegar Con Blu Ocean?',
      cards: [
        'Experiencia 100% privada para tu grupo',
        'Capitán local con experiencia',
        'Icacos y Palominos en un solo día',
        'Snorkel, bebidas y snacks incluidos',
        'Perfecto para parejas, familias y celebraciones',
        'Reserva fácil por WhatsApp',
      ],
    },
    packages: {
      title: 'Tu Tour Privado Incluye',
      boat: {
        features: [
          'Bote privado para hasta 6 personas',
          '5 horas de aventura en el Caribe',
          'Paradas en Icacos + Palominos',
          'Bebidas, snacks y música a bordo',
          'Equipo de snorkel y colchón flotante',
          'Opción de Jet Ski disponible',
        ],
        cta: 'Consultar disponibilidad por WhatsApp',
      },
    },
    clientRatings: {
      title: 'Nuestros Clientes Nos Recomiendan',
      subtitle:
        'Conoce las reseñas de viajeros que ya disfrutaron su día privado con Blu Ocean Tours.',
      bluOcean: 'Ver reseñas de Blu Ocean',
    },
    reviews: {
      title: 'Lo Que Dicen Nuestros Invitados',
      items: [
        'Blu Ocean Tours fue lo mejor de nuestro viaje a Puerto Rico.',
        'Un día privado perfecto: el bote, las paradas y el servicio fueron increíbles.',
        'Nos sentimos seguros, atendidos y completamente relajados desde el primer momento.',
        'La mejor forma de conocer Icacos y Palominos con amigos.',
      ],
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [
        {
          q: '¿Cómo reservo?',
          a: 'Escríbenos por WhatsApp y confirmaremos disponibilidad, horario y todos los detalles de tu tour privado.',
        },
        {
          q: '¿De dónde salen los tours?',
          a: 'Nuestros tours privados salen desde Fajardo, Puerto Rico.',
        },
        {
          q: '¿El tour es privado?',
          a: 'Sí. Cada tour es privado para ti y tu grupo, con capacidad de hasta 6 personas.',
        },
        {
          q: '¿Qué incluye el tour?',
          a: 'Bote, capitán, bebidas, snacks, equipo de snorkel, colchón flotante, música, sombrilla de playa y flotadores.',
        },
        {
          q: '¿Necesito experiencia para hacer snorkel o jet ski?',
          a: 'No. Te orientamos para que disfrutes el agua de forma cómoda y segura.',
        },
        {
          q: '¿Qué debo llevar?',
          a: 'Traje de baño, toalla, protector solar reef-safe, gafas de sol y ganas de pasarla bien.',
        },
      ],
    },
    finalCta: {
      headline: 'Tu Próxima Aventura en el Caribe Te Espera.',
      btnWhatsapp: 'Reservar por WhatsApp',
      btnWebsite: 'Ver disponibilidad online',
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      locationBoat: 'Fajardo, Puerto Rico',
      privateTours: 'Tours privados en bote',
    },
  },
  en: {
    nav: {
      home: 'Home',
      experience: 'The experience',
      gallery: 'Gallery',
      reviews: 'Reviews',
      faq: 'FAQ',
    },
    hero: {
      headline: 'Your Private Caribbean Day Starts Here',
      subheadline:
        'Set out from Fajardo to Icacos and Palominos on a private boat experience made for enjoying the sea at your own pace.',
      cta: 'Book with Blu Ocean',
    },
    bluOceanSection: {
      title: 'A Day at Sea, Made for You',
      description:
        'Blu Ocean Tours takes you through the crystal-clear waters of eastern Puerto Rico on a private boat for up to 6 guests. Music, snorkeling, drinks, snacks, and time to enjoy every stop.',
      features: [
        {
          title: 'Private Boat',
          desc: 'Exclusive to you and your group, up to 6 guests.',
        },
        {
          title: 'Icacos + Palominos',
          desc: 'Cruise to the most spectacular cays on the east coast.',
        },
        {
          title: 'All Included',
          desc: 'Drinks, snacks, snorkel gear, and a floating mat.',
        },
        {
          title: 'Jet Ski Option',
          desc: 'Add a little adrenaline to your day at sea.',
        },
      ],
      cta: 'Book your private tour',
    },
    whyBookUs: {
      title: 'Why Sail With Blu Ocean?',
      cards: [
        '100% private experience for your group',
        'Experienced local captain',
        'Icacos and Palominos in one day',
        'Snorkel gear, drinks, and snacks included',
        'Perfect for couples, families, and celebrations',
        'Easy WhatsApp booking',
      ],
    },
    packages: {
      title: 'Your Private Tour Includes',
      boat: {
        features: [
          'Private boat for up to 6 guests',
          '5 hours of Caribbean adventure',
          'Stops at Icacos + Palominos',
          'Drinks, snacks, and music on board',
          'Snorkel gear and floating mat',
          'Jet ski option available',
        ],
        cta: 'Ask about availability on WhatsApp',
      },
    },
    clientRatings: {
      title: 'Our Guests Recommend Us',
      subtitle:
        'Explore reviews from travelers who have already enjoyed a private day with Blu Ocean Tours.',
      bluOcean: 'Read Blu Ocean reviews',
    },
    reviews: {
      title: 'What Our Guests Say',
      items: [
        'Blu Ocean Tours was the highlight of our Puerto Rico trip.',
        'The perfect private day: the boat, stops, and service were incredible.',
        'We felt safe, cared for, and completely relaxed from the start.',
        'The best way to experience Icacos and Palominos with friends.',
      ],
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'How do I book?',
          a: 'Message us on WhatsApp and we will confirm availability, departure time, and every detail of your private tour.',
        },
        {
          q: 'Where do tours depart from?',
          a: 'Our private tours depart from Fajardo, Puerto Rico.',
        },
        {
          q: 'Is the tour private?',
          a: 'Yes. Every tour is private for your group, with capacity for up to 6 guests.',
        },
        {
          q: 'What is included?',
          a: 'Boat, captain, drinks, snacks, snorkel gear, floating mat, music, beach umbrella, and floats.',
        },
        {
          q: 'Do I need snorkeling or jet ski experience?',
          a: 'No. We will guide you so you can enjoy the water comfortably and safely.',
        },
        {
          q: 'What should I bring?',
          a: 'Swimsuit, towel, reef-safe sunscreen, sunglasses, and a great attitude.',
        },
      ],
    },
    finalCta: {
      headline: 'Your Next Caribbean Adventure Is Waiting.',
      btnWhatsapp: 'Book on WhatsApp',
      btnWebsite: 'Check availability online',
    },
    footer: {
      rights: 'All rights reserved.',
      locationBoat: 'Fajardo, Puerto Rico',
      privateTours: 'Private boat tours',
    },
  },
}
